import { LinkedSectionsModel } from '../models/linked_sections_model';
import * as _4 from 'lodash4';

export class LinkedSectionsServant {
  constructor(private ngLinkedSectionsModel: LinkedSectionsModel) {}

  areSectionsLinked(sectionId1: number, sectionId2: number) {
    return _4.includes(this.ngLinkedSectionsModel.get(sectionId1), sectionId2);
  }
}
angular.module('capability-ng-scheduler').service('ngLinkedSectionsServant', LinkedSectionsServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/servants/linked_sections_servant.ts